import React, { useState, useEffect, useRef, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { 
  LayoutDashboard, Package, UtensilsCrossed, Ticket, Users, TrendingUp, 
  Clock, CheckCircle, Truck, ChefHat, XCircle, Eye, Edit, Trash2, Plus,
  IndianRupee, ShoppingBag, ArrowUp, ArrowDown, RefreshCw, Search,
  Filter, MoreVertical, X, Save, Leaf, Image, Bell, Volume2, VolumeX,
  Settings, MapPin, Phone, Mail, Globe, MessageCircle
} from "lucide-react";
import { useHealth } from "../hooks/useHealth";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
const API = `${BACKEND_URL}/api`;
const WS_URL = BACKEND_URL 
  ? BACKEND_URL.replace('https://', 'wss://').replace('http://', 'ws://') 
  : `${window.location.protocol === 'https:' ? 'wss://' : 'ws://'}${window.location.host}`;

const FALLBACK_MENU_ITEMS = [
  { id: "starter_1", name: "Paneer Tikka", description: "Marinated cottage cheese cubes grilled to perfection in tandoor", price: 320, category: "Starters", image_url: "https://images.unsplash.com/photo-1567188040759-fb8a883dc6d8?q=80&w=800", is_veg: true, is_bestseller: true, is_available: true, tags: ["Bestseller", "Tandoor"], customizations: [] },
  { id: "starter_2", name: "Chicken Tikka", description: "Tender chicken pieces marinated in spices and grilled", price: 380, category: "Starters", image_url: "https://images.unsplash.com/photo-1599487488170-d11ec9c172f0?q=80&w=800", is_veg: false, is_bestseller: true, is_available: true, tags: ["Bestseller", "Tandoor"], customizations: [] },
  { id: "starter_3", name: "Aloo Tikki", description: "Crispy potato patties served with chutneys", price: 180, category: "Starters", image_url: "https://images.unsplash.com/photo-1606491956689-2ea866880c84?q=80&w=800", is_veg: true, is_bestseller: false, is_available: true, tags: ["Street Food"], customizations: [] },
  { id: "starter_4", name: "Fish Amritsari", description: "Crispy fried fish with Amritsari spices", price: 420, category: "Starters", image_url: "https://images.unsplash.com/photo-1534080564583-6be75777b70a?q=80&w=800", is_veg: false, is_bestseller: false, is_available: true, tags: ["Fried", "Spicy"], customizations: [] },
  { id: "main_1", name: "Butter Chicken", description: "Tender chicken in a rich, creamy tomato gravy with butter", price: 450, category: "Mains", image_url: "https://images.unsplash.com/photo-1588166524941-3bf61a9c41db?q=80&w=800", is_veg: false, is_bestseller: true, is_available: true, tags: ["Bestseller", "Creamy"], customizations: [] },
  { id: "main_2", name: "Dal Makhani", description: "12-hour slow cooked black lentils with cream and butter", price: 280, category: "Mains", image_url: "https://images.unsplash.com/photo-1546833999-b9f581a1996d?q=80&w=800", is_veg: true, is_bestseller: true, is_available: true, tags: ["Bestseller", "Slow Cooked"], customizations: [] },
  { id: "main_3", name: "Kadai Paneer", description: "Cottage cheese cooked with bell peppers in kadai masala", price: 320, category: "Mains", image_url: "https://images.unsplash.com/photo-1631452180519-c014fe946bc7?q=80&w=800", is_veg: true, is_bestseller: false, is_available: true, tags: ["Spicy", "Paneer"], customizations: [] },
  { id: "main_4", name: "Rogan Josh", description: "Kashmiri style slow-cooked lamb in aromatic spices", price: 520, category: "Mains", image_url: "https://images.unsplash.com/photo-1545247181-516773cae754?q=80&w=800", is_veg: false, is_bestseller: false, is_available: true, tags: ["Kashmiri", "Premium"], customizations: [] },
  { id: "main_5", name: "Palak Paneer", description: "Cottage cheese cubes in creamy spinach gravy", price: 290, category: "Mains", image_url: "https://images.unsplash.com/photo-1618449840665-9ed506d73a34?q=80&w=800", is_veg: true, is_bestseller: false, is_available: true, tags: ["Healthy", "Creamy"], customizations: [] },
  { id: "main_6", name: "Chicken Biryani", description: "Fragrant basmati rice layered with spiced chicken", price: 380, category: "Mains", image_url: "https://images.unsplash.com/photo-1563379091339-03b21ab4a4f8?q=80&w=800", is_veg: false, is_bestseller: true, is_available: true, tags: ["Bestseller", "Rice"], customizations: [] },
  { id: "bread_1", name: "Butter Naan", description: "Soft leavened bread brushed with butter", price: 60, category: "Breads", image_url: "https://images.unsplash.com/photo-1565557623262-b51c2513a641?q=80&w=800", is_veg: true, is_bestseller: true, is_available: true, tags: [], customizations: [] },
  { id: "bread_2", name: "Garlic Naan", description: "Naan topped with garlic and coriander", price: 80, category: "Breads", image_url: "https://images.unsplash.com/photo-1601050690597-df0568f70950?q=80&w=800", is_veg: true, is_bestseller: false, is_available: true, tags: [], customizations: [] },
  { id: "bread_3", name: "Laccha Paratha", description: "Layered whole wheat bread", price: 70, category: "Breads", image_url: "https://images.unsplash.com/photo-1585937421612-70a008356fbe?q=80&w=800", is_veg: true, is_bestseller: false, is_available: true, tags: [], customizations: [] },
  { id: "bread_4", name: "Stuffed Kulcha", description: "Naan stuffed with spiced potatoes or paneer", price: 100, category: "Breads", image_url: "https://images.unsplash.com/photo-1574653853027-5d65dd32e2cd?q=80&w=800", is_veg: true, is_bestseller: false, is_available: true, tags: ["Stuffed"], customizations: [] },
  { id: "combo_1", name: "Veg Thali", description: "Dal, Paneer, Sabzi, Rice, 2 Rotis, Raita, Salad, Sweet", price: 350, category: "Combos", image_url: "https://images.unsplash.com/photo-1546833999-b9f581a1996d?q=80&w=800", is_veg: true, is_bestseller: true, is_available: true, tags: ["Value", "Complete Meal"], customizations: [] },
  { id: "combo_2", name: "Non-Veg Thali", description: "Chicken Curry, Dal, Rice, 2 Rotis, Raita, Salad, Sweet", price: 450, category: "Combos", image_url: "https://images.unsplash.com/photo-1567337710282-00832b415979?q=80&w=800", is_veg: false, is_bestseller: true, is_available: true, tags: ["Value", "Complete Meal"], customizations: [] },
  { id: "combo_3", name: "Biryani Combo", description: "Chicken Biryani with Raita and Salan", price: 420, category: "Combos", image_url: "https://images.unsplash.com/photo-1563379091339-03b21ab4a4f8?q=80&w=800", is_veg: false, is_bestseller: false, is_available: true, tags: ["Rice", "Combo"], customizations: [] },
  { id: "bev_1", name: "Masala Chai", description: "Traditional Indian spiced tea", price: 50, category: "Beverages", image_url: "https://images.unsplash.com/photo-1561336313-0bd5e0b27ec8?q=80&w=800", is_veg: true, is_bestseller: false, is_available: true, tags: [], customizations: [] },
  { id: "bev_2", name: "Lassi", description: "Sweet or salted yogurt drink", price: 80, category: "Beverages", image_url: "https://images.unsplash.com/photo-1626201850760-208b18b474ff?q=80&w=800", is_veg: true, is_bestseller: true, is_available: true, tags: [], customizations: [] },
  { id: "bev_3", name: "Fresh Lime Soda", description: "Refreshing lime with soda, sweet or salted", price: 60, category: "Beverages", image_url: "https://images.unsplash.com/photo-1513558161293-cdaf765ed2fd?q=80&w=800", is_veg: true, is_bestseller: false, is_available: true, tags: [], customizations: [] },
  { id: "dessert_1", name: "Gulab Jamun", description: "Deep fried milk dumplings in sugar syrup (2 pcs)", price: 100, category: "Desserts", image_url: "https://images.unsplash.com/photo-1666190077072-ee1489e7cd5b?q=80&w=800", is_veg: true, is_bestseller: true, is_available: true, tags: [], customizations: [] },
  { id: "dessert_2", name: "Kulfi", description: "Traditional Indian ice cream with pistachios", price: 120, category: "Desserts", image_url: "https://images.unsplash.com/photo-1623073284788-0d846f75e329?q=80&w=800", is_veg: true, is_bestseller: false, is_available: true, tags: [], customizations: [] },
  { id: "dessert_3", name: "Kheer", description: "Creamy rice pudding with cardamom and nuts", price: 110, category: "Desserts", image_url: "https://images.unsplash.com/photo-1631452180539-96aca7d48617?q=80&w=800", is_veg: true, is_bestseller: false, is_available: true, tags: [], customizations: [] }
];

const BackendStatusBadge = () => {
  const { state, latencyMs, lastChecked } = useHealth(30000);

  const getStatusColor = () => {
    switch (state) {
      case "ok": return "#4CAF50";
      case "degraded": return "#FFC107";
      case "down": return "#f44336";
      default: return "#757575";
    }
  };

  const getStatusLabel = () => {
    switch (state) {
      case "ok": return "Backend OK";
      case "degraded": return "Latency High";
      case "down": return "Backend Offline";
      default: return "Checking Backend...";
    }
  };

  return (
    <div className="backend-status-badge" style={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: '8px',
      background: 'var(--gray-100)',
      padding: '6px 12px',
      borderRadius: 'var(--radius-full)',
      border: '1px solid var(--gray-300)',
      fontSize: '13px',
      fontWeight: '500',
      color: 'var(--gray-700)',
    }}>
      <span style={{
        width: '8px',
        height: '8px',
        borderRadius: '50%',
        background: getStatusColor(),
        boxShadow: `0 0 8px ${getStatusColor()}80`,
      }} />
      <span>{getStatusLabel()}</span>
      {latencyMs !== undefined && state !== "down" && (
        <span style={{ color: 'var(--gray-500)', fontSize: '11px' }}>
          ({Math.round(latencyMs)}ms)
        </span>
      )}
      {lastChecked && (
        <span style={{ color: 'var(--gray-500)', fontSize: '11px', borderLeft: '1px solid var(--gray-300)', paddingLeft: '8px' }}>
          {lastChecked.toLocaleTimeString()}
        </span>
      )}
    </div>
  );
};

// Notification sound
const playNotificationSound = () => {
  const audio = new Audio('data:audio/wav;base64,UklGRnoGAABXQVZFZm10IBAAAAABAAEAQB8AAEAfAAABAAgAZGF0YQoGAACBhYqFbF1fdJivrJBhNjVgodDbq2EcBj+a2teleRYAQKnY5pF3BRxFsu/ujWQDAEnN/fWDSwAAS///+3Y6AABO//z7cioAAFT/+vVuGgAAWv/27WoSAABf/+/oZQsAAGT/5+RfBQAAaf/d3loAAABu/9TYVAIAAHP/y9JPBQAAZ//F0EoIAABb/8HOSREAAFD/wMdEGgAAR/+9xT8jAAA//7rDOiwAADj/t8E1NQAAMv+0vzA+AAAr/7G9K0cAACb/r7smUQAAIf+tuhxbAAAd/6y5F2UAAB3/q7gRbwAAHv+quAt5AAAf/6m3BoMAACD/qLYAjQAAIf+otZeXAAAi/6e0');
  audio.play().catch(() => {});
};

const AdminDashboard = ({ user, token }) => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("overview");
  const [stats, setStats] = useState(null);
  const [orders, setOrders] = useState([]);
  const [menuItems, setMenuItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [authChecked, setAuthChecked] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [soundEnabled, setSoundEnabled] = useState(true);
  const wsRef = useRef(null);

  // WebSocket connection for real-time updates with polling fallback
  const connectWebSocket = useCallback(() => {
    // Try WebSocket first
    try {
      if (wsRef.current?.readyState === WebSocket.OPEN) return;
      
      const ws = new WebSocket(`${WS_URL}/ws/admin`);
      
      ws.onopen = () => {
        console.log('WebSocket connected');
        // Send ping every 30 seconds to keep alive
        const pingInterval = setInterval(() => {
          if (ws.readyState === WebSocket.OPEN) {
            ws.send('ping');
          }
        }, 30000);
        ws.pingInterval = pingInterval;
      };
      
      ws.onmessage = (event) => {
        const data = JSON.parse(event.data);
        if (data.type === 'new_order') {
          // Play notification sound
          if (soundEnabled) {
            playNotificationSound();
          }
          // Add to notifications
          setNotifications(prev => [{
            id: Date.now(),
            ...data.order,
            timestamp: new Date().toISOString()
          }, ...prev.slice(0, 9)]);
          // Refresh data
          fetchData();
        }
      };
      
      ws.onclose = () => {
        console.log('WebSocket disconnected, using polling fallback');
        if (ws.pingInterval) clearInterval(ws.pingInterval);
        // Fall back to polling
        startPolling();
      };
      
      ws.onerror = (error) => {
        console.log('WebSocket error, using polling fallback');
        startPolling();
      };
      
      wsRef.current = ws;
    } catch (err) {
      console.log('WebSocket not supported, using polling');
      startPolling();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [soundEnabled]);

  // Polling fallback for environments without WebSocket
  const pollingRef = useRef(null);
  const lastOrderCountRef = useRef(0);
  
  const startPolling = useCallback(() => {
    if (pollingRef.current) return; // Already polling
    
    pollingRef.current = setInterval(async () => {
      try {
        const res = await axios.get(`${API}/admin/stats`, { headers: { Authorization: `Bearer ${token}` } });
        const newOrderCount = res.data.total_orders;
        
        if (lastOrderCountRef.current > 0 && newOrderCount > lastOrderCountRef.current) {
          // New order detected
          if (soundEnabled) {
            playNotificationSound();
          }
          fetchData();
          // Show notification
          setNotifications(prev => [{
            id: Date.now(),
            order_number: `New Order`,
            user_name: "Customer",
            total: 0,
            items_count: 0,
            order_type: "order",
            timestamp: new Date().toISOString()
          }, ...prev.slice(0, 9)]);
        }
        lastOrderCountRef.current = newOrderCount;
      } catch (err) {
        console.log('Polling error:', err);
      }
    }, 10000); // Poll every 10 seconds
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token, soundEnabled]);

  useEffect(() => {
    // Wait for auth to be checked
    if (user === null && token) {
      // Still loading user
      return;
    }
    setAuthChecked(true);
    
    if (!(user?.is_admin || user?.roles?.dhaba === 'admin' || user?.roles?.dhaba === 'employee' || user?.roles?.cafe === 'admin' || user?.roles?.cafe === 'employee')) {
      navigate("/login?redirect=/admin");
      return;
    }
    fetchData();
    connectWebSocket();
    
    // Initialize last order count
    axios.get(`${API}/admin/stats`, { headers: { Authorization: `Bearer ${token}` } })
      .then(res => { lastOrderCountRef.current = res.data.total_orders; })
      .catch(() => {});
    
    return () => {
      if (wsRef.current) {
        if (wsRef.current.pingInterval) clearInterval(wsRef.current.pingInterval);
        wsRef.current.close();
      }
      if (pollingRef.current) {
        clearInterval(pollingRef.current);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, token, navigate, connectWebSocket]);

  const fetchData = async () => {
    setLoading(true);
    try {
      // Fetch stats and orders together (require auth)
      const [statsRes, ordersRes] = await Promise.all([
        axios.get(`${API}/admin/stats`, { headers: { Authorization: `Bearer ${token}` } }),
        axios.get(`${API}/admin/orders`, { headers: { Authorization: `Bearer ${token}` } })
      ]);
      setStats(statsRes.data);
      setOrders(ordersRes.data.orders);
    } catch (err) {
      console.error("Failed to fetch admin stats/orders", err);
    }
    // Fetch menu independently with fallback
    try {
      const menuRes = await axios.get(`${API}/menu`);
      setMenuItems(menuRes.data.items);
    } catch (err) {
      console.warn("Failed to fetch menu from API, using fallback data", err);
      setMenuItems(FALLBACK_MENU_ITEMS);
    }
    setLoading(false);
  };

  const tabs = [
    { id: "overview", label: "Overview", icon: LayoutDashboard },
    { id: "orders", label: "Orders", icon: Package },
    { id: "menu", label: "Menu", icon: UtensilsCrossed },
    { id: "coupons", label: "Coupons", icon: Ticket },
    { id: "settings", label: "Settings", icon: Settings },
  ];

  if (!authChecked || loading) {
    return (
      <div className="admin-loading">
        <RefreshCw className="spin" size={40} />
        <p>Loading dashboard...</p>
      </div>
    );
  }

  if (!(user?.is_admin || user?.roles?.dhaba === 'admin' || user?.roles?.dhaba === 'employee' || user?.roles?.cafe === 'admin' || user?.roles?.cafe === 'employee')) {
    return null; // Will redirect
  }

  return (
    <div className="admin-dashboard" data-testid="admin-dashboard">
      {/* Notification Toast */}
      {notifications.length > 0 && (
        <div className="notification-toast">
          <div className="toast-header">
            <Bell size={18} />
            <span>New Order!</span>
            <button onClick={() => setNotifications([])}><X size={16} /></button>
          </div>
          <div className="toast-body">
            <strong>#{notifications[0].order_number}</strong>
            <p>{notifications[0].user_name} - ₹{notifications[0].total?.toFixed(0)}</p>
            <p>{notifications[0].items_count} items • {notifications[0].order_type}</p>
          </div>
        </div>
      )}

      {/* Sidebar */}
      <aside className="admin-sidebar">
        <div className="admin-logo">
          <span>🍛</span>
          <h2>Admin Panel</h2>
        </div>
        <nav className="admin-nav">
          {tabs.map(tab => {
            const Icon = tab.icon;
            return (
              <button
                key={tab.id}
                className={`nav-item ${activeTab === tab.id ? "active" : ""}`}
                onClick={() => setActiveTab(tab.id)}
                data-testid={`admin-tab-${tab.id}`}
              >
                <Icon size={20} />
                <span>{tab.label}</span>
                {tab.id === "orders" && stats?.pending_orders > 0 && (
                  <span className="nav-badge">{stats.pending_orders}</span>
                )}
              </button>
            );
          })}
        </nav>
        <div className="admin-user">
          <div className="user-avatar">{user?.name?.charAt(0)}</div>
          <div className="user-info">
            <span className="user-name">{user?.name}</span>
            <span className="user-role">Administrator</span>
          </div>
        </div>
      </aside>

      {/* Main Content */}
      <main className="admin-main">
        <header className="admin-header">
          <h1>{tabs.find(t => t.id === activeTab)?.label}</h1>
          <div className="header-actions">
            <BackendStatusBadge />
            <button 
              className={`sound-toggle ${soundEnabled ? 'on' : 'off'}`}
              onClick={() => setSoundEnabled(!soundEnabled)}
              title={soundEnabled ? 'Mute notifications' : 'Enable notifications'}
            >
              {soundEnabled ? <Volume2 size={18} /> : <VolumeX size={18} />}
            </button>
            <button className="refresh-btn" onClick={fetchData}>
              <RefreshCw size={18} /> Refresh
            </button>
          </div>
        </header>

        <div className="admin-content">
          {activeTab === "overview" && <OverviewTab stats={stats} orders={orders} />}
          {activeTab === "orders" && <OrdersTab orders={orders} token={token} onUpdate={fetchData} />}
          {activeTab === "menu" && <MenuTab menuItems={menuItems} token={token} onUpdate={fetchData} />}
          {activeTab === "coupons" && <CouponsTab token={token} />}
          {activeTab === "settings" && <SettingsTab token={token} />}
        </div>
      </main>
    </div>
  );
};

// Overview Tab
const OverviewTab = ({ stats, orders }) => {
  const recentOrders = orders?.slice(0, 5) || [];
  
  const statCards = [
    { label: "Total Orders", value: stats?.total_orders || 0, icon: ShoppingBag, color: "#2E7D32", trend: "+12%" },
    { label: "Today's Orders", value: stats?.today_orders || 0, icon: Package, color: "#FF6B35", trend: "+8%" },
    { label: "Total Revenue", value: `₹${(stats?.total_revenue || 0).toLocaleString()}`, icon: IndianRupee, color: "#1976D2", trend: "+15%" },
    { label: "Pending Orders", value: stats?.pending_orders || 0, icon: Clock, color: "#E53935", trend: "-3%" },
  ];

  return (
    <div className="overview-tab">
      {/* Stats Cards */}
      <div className="stats-grid">
        {statCards.map((stat, i) => {
          const Icon = stat.icon;
          const isPositive = stat.trend.startsWith("+");
          return (
            <div key={i} className="stat-card" style={{ "--card-color": stat.color }}>
              <div className="stat-icon">
                <Icon size={24} />
              </div>
              <div className="stat-info">
                <span className="stat-value">{stat.value}</span>
                <span className="stat-label">{stat.label}</span>
              </div>
              <div className={`stat-trend ${isPositive ? "up" : "down"}`}>
                {isPositive ? <ArrowUp size={14} /> : <ArrowDown size={14} />}
                {stat.trend}
              </div>
            </div>
          );
        })}
      </div>

      {/* Recent Orders */}
      <div className="recent-orders-section">
        <h3>Recent Orders</h3>
        <div className="orders-table-wrapper">
          <table className="orders-table">
            <thead>
              <tr>
                <th>Order #</th>
                <th>Channel</th>
                <th>Customer</th>
                <th>Items</th>
                <th>Total</th>
                <th>Status</th>
                <th>Time</th>
              </tr>
            </thead>
            <tbody>
              {recentOrders.map(order => (
                <tr key={order.id}>
                  <td className="order-num">{order.order_number}</td>
                  <td><ChannelBadge channel={order.channel || "OWN_DHABA"} /></td>
                  <td>{order.user_name}</td>
                  <td>{order.items?.length} items</td>
                  <td className="order-total">₹{order.total?.toFixed(0)}</td>
                  <td><StatusBadge status={order.status} /></td>
                  <td className="order-time">{new Date(order.created_at).toLocaleTimeString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Order Status Distribution */}
      <div className="status-distribution">
        <h3>Order Status</h3>
        <div className="status-cards">
          {["placed", "confirmed", "preparing", "ready", "delivered"].map(status => {
            const count = orders?.filter(o => o.status === status).length || 0;
            return (
              <div key={status} className="status-card">
                <StatusBadge status={status} />
                <span className="status-count">{count}</span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

// Orders Tab
const OrdersTab = ({ orders, token, onUpdate }) => {
  const [filter, setFilter] = useState("all");
  const [channelFilter, setChannelFilter] = useState("all");
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [updating, setUpdating] = useState(false);

  const filteredOrders = orders.filter(o => {
    const matchesStatus = filter === "all" || o.status === filter;
    const matchesChannel = channelFilter === "all" || o.channel === channelFilter;
    return matchesStatus && matchesChannel;
  });

  const updateStatus = async (orderId, newStatus) => {
    setUpdating(true);
    try {
      await axios.put(
        `${API}/admin/orders/${orderId}/status`,
        { status: newStatus },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      onUpdate();
      setSelectedOrder(null);
    } catch (err) {
      alert("Failed to update status");
    }
    setUpdating(false);
  };

  const statusFlow = ["placed", "confirmed", "preparing", "ready", "out_for_delivery", "delivered"];

  return (
    <div className="orders-tab">
      {/* Filters */}
      <div className="orders-filters" style={{ display: "flex", flexWrap: "wrap", gap: "16px", justifyContent: "space-between", alignItems: "center", marginBottom: "24px" }}>
        <div className="filter-tabs" style={{ marginBottom: 0 }}>
          {["all", "placed", "confirmed", "preparing", "ready", "delivered"].map(status => (
            <button
              key={status}
              className={`filter-tab ${filter === status ? "active" : ""}`}
              onClick={() => setFilter(status)}
            >
              {status === "all" ? "All Orders" : status.charAt(0).toUpperCase() + status.slice(1)}
              <span className="count">
                {status === "all" ? orders.length : orders.filter(o => o.status === status).length}
              </span>
            </button>
          ))}
        </div>
        
        {/* Channel Filter Selector */}
        <div className="channel-filter-selector" style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <span style={{ fontSize: "14px", fontWeight: "600", color: "var(--gray-700)" }}>Channel:</span>
          <select 
            value={channelFilter} 
            onChange={(e) => setChannelFilter(e.target.value)}
            style={{
              padding: "8px 16px",
              borderRadius: "8px",
              border: "1px solid var(--gray-300)",
              background: "white",
              fontSize: "14px",
              fontWeight: "500",
              color: "var(--gray-800)",
              outline: "none",
              cursor: "pointer"
            }}
          >
            <option value="all">All Channels</option>
            <option value="OWN_DHABA">Dhaba Website</option>
            <option value="OWN_CAFE">Cafe Website</option>
            <option value="SWIGGY">Swiggy</option>
            <option value="ZOMATO">Zomato</option>
            <option value="DINE_IN">Dine-in</option>
          </select>
        </div>
      </div>

      {/* Orders List */}
      <div className="orders-list-admin">
        {filteredOrders.map(order => (
          <div key={order.id} className="order-card-admin" data-testid={`admin-order-${order.order_number}`}>
            <div className="order-header-admin">
              <div className="order-id" style={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: "4px" }}>
                <span className="order-number">#{order.order_number}</span>
                <span className="order-type-badge">{order.order_type}</span>
                <ChannelBadge channel={order.channel || "OWN_DHABA"} />
              </div>
              <StatusBadge status={order.status} />
            </div>

            <div className="order-body">
              <div className="order-customer">
                <strong>{order.user_name}</strong>
                <span>{order.user_phone}</span>
              </div>
              <div className="order-items-list">
                {order.items?.map((item, i) => (
                  <span key={i} className="order-item-tag">
                    {item.menu_item?.name} × {item.quantity}
                  </span>
                ))}
              </div>
              {order.delivery_address && (
                <div className="order-address">
                  📍 {order.delivery_address.address_line}, {order.delivery_address.city}
                </div>
              )}
            </div>

            <div className="order-footer-admin">
              <div className="order-meta">
                <span className="order-total-admin">₹{order.total?.toFixed(0)}</span>
                <span className="order-time-admin">{new Date(order.created_at).toLocaleString()}</span>
              </div>
              <div className="order-actions">
                <button className="action-btn view" onClick={() => setSelectedOrder(order)}>
                  <Eye size={16} /> View
                </button>
                {order.status !== "delivered" && order.status !== "cancelled" && (
                  <button 
                    className="action-btn update"
                    onClick={() => {
                      const currentIdx = statusFlow.indexOf(order.status);
                      if (currentIdx < statusFlow.length - 1) {
                        updateStatus(order.id, statusFlow[currentIdx + 1]);
                      }
                    }}
                    disabled={updating}
                  >
                    <CheckCircle size={16} /> Next Status
                  </button>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Order Detail Modal */}
      {selectedOrder && (
        <div className="modal-overlay" onClick={() => setSelectedOrder(null)}>
          <div className="modal-content" onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <h3>Order #{selectedOrder.order_number}</h3>
              <button className="close-btn" onClick={() => setSelectedOrder(null)}><X size={20} /></button>
            </div>
            <div className="modal-body">
              <div className="detail-section">
                <h4>Customer Details</h4>
                <p><strong>Name:</strong> {selectedOrder.user_name}</p>
                <p><strong>Phone:</strong> {selectedOrder.user_phone}</p>
                <p><strong>Order Type:</strong> {selectedOrder.order_type}</p>
                {selectedOrder.delivery_address && (
                  <p><strong>Address:</strong> {selectedOrder.delivery_address.address_line}, {selectedOrder.delivery_address.city} - {selectedOrder.delivery_address.pincode}</p>
                )}
              </div>
              <div className="detail-section">
                <h4>Order Items</h4>
                {selectedOrder.items?.map((item, i) => (
                  <div key={i} className="detail-item">
                    <span>{item.menu_item?.name} × {item.quantity}</span>
                    <span>₹{item.item_total?.toFixed(0)}</span>
                  </div>
                ))}
                <div className="detail-totals">
                  <div className="detail-item"><span>Subtotal</span><span>₹{selectedOrder.subtotal?.toFixed(0)}</span></div>
                  {selectedOrder.discount > 0 && <div className="detail-item discount"><span>Discount</span><span>-₹{selectedOrder.discount?.toFixed(0)}</span></div>}
                  <div className="detail-item"><span>Tax</span><span>₹{selectedOrder.tax?.toFixed(0)}</span></div>
                  <div className="detail-item"><span>Delivery</span><span>₹{selectedOrder.delivery_fee?.toFixed(0)}</span></div>
                  <div className="detail-item total"><span>Total</span><span>₹{selectedOrder.total?.toFixed(0)}</span></div>
                </div>
              </div>
              <div className="detail-section">
                <h4>Update Status</h4>
                <div className="status-buttons">
                  {statusFlow.map(status => (
                    <button
                      key={status}
                      className={`status-btn ${selectedOrder.status === status ? "current" : ""}`}
                      onClick={() => updateStatus(selectedOrder.id, status)}
                      disabled={updating || selectedOrder.status === status}
                    >
                      {status.replace("_", " ")}
                    </button>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

// Menu Tab
const MenuTab = ({ menuItems, token, onUpdate }) => {
  const [showForm, setShowForm] = useState(false);
  const [editItem, setEditItem] = useState(null);
  const [formData, setFormData] = useState({
    name: "", description: "", price: "", category: "Starters",
    image_url: "", is_veg: true, is_bestseller: false, is_available: true
  });
  const [saving, setSaving] = useState(false);

  const categories = ["Starters", "Mains", "Breads", "Combos", "Beverages", "Desserts"];

  const openForm = (item = null) => {
    if (item) {
      setFormData({ ...item, price: item.price.toString() });
      setEditItem(item);
    } else {
      setFormData({
        name: "", description: "", price: "", category: "Starters",
        image_url: "", is_veg: true, is_bestseller: false, is_available: true
      });
      setEditItem(null);
    }
    setShowForm(true);
  };

  const saveItem = async () => {
    if (!formData.name || !formData.price) {
      alert("Name and price are required");
      return;
    }
    setSaving(true);
    try {
      const data = { ...formData, price: parseFloat(formData.price), tags: [] };
      if (editItem) {
        await axios.put(`${API}/admin/menu/${editItem.id}`, data, { headers: { Authorization: `Bearer ${token}` } });
      } else {
        await axios.post(`${API}/admin/menu`, data, { headers: { Authorization: `Bearer ${token}` } });
      }
      onUpdate();
      setShowForm(false);
    } catch (err) {
      alert("Failed to save item");
    }
    setSaving(false);
  };

  const deleteItem = async (id) => {
    if (!window.confirm("Are you sure you want to delete this item?")) return;
    try {
      await axios.delete(`${API}/admin/menu/${id}`, { headers: { Authorization: `Bearer ${token}` } });
      onUpdate();
    } catch (err) {
      alert("Failed to delete item");
    }
  };

  return (
    <div className="menu-tab-admin">
      <div className="menu-header-admin">
        <p>{menuItems.length} items in menu</p>
        <button className="add-btn" onClick={() => openForm()} data-testid="add-menu-item-btn">
          <Plus size={18} /> Add Item
        </button>
      </div>

      <div className="menu-grid-admin">
        {menuItems.map(item => (
          <div key={item.id} className="menu-card-admin" data-testid={`menu-card-${item.id}`}>
            <div className="menu-card-image">
              <img src={item.image_url} alt={item.name} />
              <div className="menu-card-badges">
                {item.is_veg ? <span className="badge veg"><Leaf size={12} /> Veg</span> : <span className="badge non-veg">Non-Veg</span>}
                {item.is_bestseller && <span className="badge bestseller">Bestseller</span>}
                {!item.is_available && <span className="badge unavailable">Unavailable</span>}
              </div>
            </div>
            <div className="menu-card-body">
              <h4>{item.name}</h4>
              <p className="menu-card-desc">{item.description}</p>
              <div className="menu-card-footer">
                <span className="menu-card-price">₹{item.price}</span>
                <span className="menu-card-category">{item.category}</span>
              </div>
            </div>
            <div className="menu-card-actions">
              <button className="edit-btn" onClick={() => openForm(item)}><Edit size={16} /></button>
              <button className="delete-btn" onClick={() => deleteItem(item.id)}><Trash2 size={16} /></button>
            </div>
          </div>
        ))}
      </div>

      {/* Add/Edit Form Modal */}
      {showForm && (
        <div className="modal-overlay" onClick={() => setShowForm(false)}>
          <div className="modal-content form-modal" onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <h3>{editItem ? "Edit Menu Item" : "Add Menu Item"}</h3>
              <button className="close-btn" onClick={() => setShowForm(false)}><X size={20} /></button>
            </div>
            <div className="modal-body">
              <div className="form-grid">
                <div className="form-group">
                  <label>Name *</label>
                  <input type="text" value={formData.name} onChange={e => setFormData({ ...formData, name: e.target.value })} placeholder="Item name" />
                </div>
                <div className="form-group">
                  <label>Price *</label>
                  <input type="number" value={formData.price} onChange={e => setFormData({ ...formData, price: e.target.value })} placeholder="Price in ₹" />
                </div>
                <div className="form-group full-width">
                  <label>Description</label>
                  <textarea value={formData.description} onChange={e => setFormData({ ...formData, description: e.target.value })} placeholder="Item description" rows={3} />
                </div>
                <div className="form-group">
                  <label>Category</label>
                  <select value={formData.category} onChange={e => setFormData({ ...formData, category: e.target.value })}>
                    {categories.map(cat => <option key={cat} value={cat}>{cat}</option>)}
                  </select>
                </div>
                <div className="form-group">
                  <label>Image URL</label>
                  <input type="text" value={formData.image_url} onChange={e => setFormData({ ...formData, image_url: e.target.value })} placeholder="https://..." />
                </div>
                <div className="form-group checkboxes">
                  <label className="checkbox-label">
                    <input type="checkbox" checked={formData.is_veg} onChange={e => setFormData({ ...formData, is_veg: e.target.checked })} />
                    Vegetarian
                  </label>
                  <label className="checkbox-label">
                    <input type="checkbox" checked={formData.is_bestseller} onChange={e => setFormData({ ...formData, is_bestseller: e.target.checked })} />
                    Bestseller
                  </label>
                  <label className="checkbox-label">
                    <input type="checkbox" checked={formData.is_available} onChange={e => setFormData({ ...formData, is_available: e.target.checked })} />
                    Available
                  </label>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button className="cancel-btn" onClick={() => setShowForm(false)}>Cancel</button>
              <button className="save-btn" onClick={saveItem} disabled={saving}>
                <Save size={16} /> {saving ? "Saving..." : "Save Item"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

// Coupons Tab
const CouponsTab = ({ token }) => {
  const [coupons, setCoupons] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({
    code: "", discount_type: "percentage", discount_value: "",
    min_order_value: "0", max_discount: "", valid_from: "", valid_until: "", is_active: true
  });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    fetchCoupons();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchCoupons = async () => {
    try {
      const res = await axios.get(`${API}/admin/coupons`, { headers: { Authorization: `Bearer ${token}` } });
      setCoupons(res.data.coupons || []);
    } catch (err) {
      // Coupons endpoint might not exist, use empty array
      setCoupons([]);
    }
  };

  const saveCoupon = async () => {
    if (!formData.code || !formData.discount_value) {
      alert("Code and discount value are required");
      return;
    }
    setSaving(true);
    try {
      const data = {
        ...formData,
        discount_value: parseFloat(formData.discount_value),
        min_order_value: parseFloat(formData.min_order_value || 0),
        max_discount: formData.max_discount ? parseFloat(formData.max_discount) : null,
        valid_from: formData.valid_from || new Date().toISOString(),
        valid_until: formData.valid_until || new Date(Date.now() + 365 * 24 * 60 * 60 * 1000).toISOString()
      };
      await axios.post(`${API}/admin/coupons`, data, { headers: { Authorization: `Bearer ${token}` } });
      fetchCoupons();
      setShowForm(false);
      setFormData({
        code: "", discount_type: "percentage", discount_value: "",
        min_order_value: "0", max_discount: "", valid_from: "", valid_until: "", is_active: true
      });
    } catch (err) {
      alert("Failed to create coupon");
    }
    setSaving(false);
  };

  return (
    <div className="coupons-tab">
      <div className="coupons-header">
        <p>{coupons.length} active coupons</p>
        <button className="add-btn" onClick={() => setShowForm(true)}>
          <Plus size={18} /> Create Coupon
        </button>
      </div>

      <div className="coupons-grid">
        {coupons.map(coupon => (
          <div key={coupon.id} className="coupon-card">
            <div className="coupon-code">{coupon.code}</div>
            <div className="coupon-discount">
              {coupon.discount_type === "percentage" ? `${coupon.discount_value}% OFF` : `₹${coupon.discount_value} OFF`}
            </div>
            <div className="coupon-details">
              <span>Min order: ₹{coupon.min_order_value}</span>
              {coupon.max_discount && <span>Max discount: ₹{coupon.max_discount}</span>}
            </div>
            <div className={`coupon-status ${coupon.is_active ? "active" : "inactive"}`}>
              {coupon.is_active ? "Active" : "Inactive"}
            </div>
          </div>
        ))}
      </div>

      {/* Create Coupon Modal */}
      {showForm && (
        <div className="modal-overlay" onClick={() => setShowForm(false)}>
          <div className="modal-content form-modal" onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <h3>Create Coupon</h3>
              <button className="close-btn" onClick={() => setShowForm(false)}><X size={20} /></button>
            </div>
            <div className="modal-body">
              <div className="form-grid">
                <div className="form-group">
                  <label>Coupon Code *</label>
                  <input type="text" value={formData.code} onChange={e => setFormData({ ...formData, code: e.target.value.toUpperCase() })} placeholder="e.g., SAVE20" />
                </div>
                <div className="form-group">
                  <label>Discount Type</label>
                  <select value={formData.discount_type} onChange={e => setFormData({ ...formData, discount_type: e.target.value })}>
                    <option value="percentage">Percentage (%)</option>
                    <option value="fixed">Fixed Amount (₹)</option>
                  </select>
                </div>
                <div className="form-group">
                  <label>Discount Value *</label>
                  <input type="number" value={formData.discount_value} onChange={e => setFormData({ ...formData, discount_value: e.target.value })} placeholder={formData.discount_type === "percentage" ? "e.g., 20" : "e.g., 100"} />
                </div>
                <div className="form-group">
                  <label>Min Order Value</label>
                  <input type="number" value={formData.min_order_value} onChange={e => setFormData({ ...formData, min_order_value: e.target.value })} placeholder="0" />
                </div>
                <div className="form-group">
                  <label>Max Discount (for %)</label>
                  <input type="number" value={formData.max_discount} onChange={e => setFormData({ ...formData, max_discount: e.target.value })} placeholder="Optional" />
                </div>
                <div className="form-group checkboxes">
                  <label className="checkbox-label">
                    <input type="checkbox" checked={formData.is_active} onChange={e => setFormData({ ...formData, is_active: e.target.checked })} />
                    Active
                  </label>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button className="cancel-btn" onClick={() => setShowForm(false)}>Cancel</button>
              <button className="save-btn" onClick={saveCoupon} disabled={saving}>
                <Save size={16} /> {saving ? "Creating..." : "Create Coupon"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

// Status Badge Component
const StatusBadge = ({ status }) => {
  const statusConfig = {
    placed: { color: "#FFA726", icon: Clock, label: "Placed" },
    confirmed: { color: "#42A5F5", icon: CheckCircle, label: "Confirmed" },
    preparing: { color: "#AB47BC", icon: ChefHat, label: "Preparing" },
    ready: { color: "#66BB6A", icon: Package, label: "Ready" },
    out_for_delivery: { color: "#26C6DA", icon: Truck, label: "Out for Delivery" },
    delivered: { color: "#4CAF50", icon: CheckCircle, label: "Delivered" },
    cancelled: { color: "#EF5350", icon: XCircle, label: "Cancelled" }
  };

  const config = statusConfig[status] || statusConfig.placed;
  const Icon = config.icon;

  return (
    <span className="status-badge" style={{ background: `${config.color}20`, color: config.color }}>
      <Icon size={14} /> {config.label}
    </span>
  );
};

// Channel Badge Component
const ChannelBadge = ({ channel }) => {
  const channelConfig = {
    OWN_DHABA: { color: "#E65100", label: "Dhaba Web" },
    OWN_CAFE: { color: "#6F4E37", label: "Cafe Web" },
    SWIGGY: { color: "#FC8019", label: "Swiggy" },
    ZOMATO: { color: "#CB202D", label: "Zomato" },
    DINE_IN: { color: "#1E88E5", label: "Dine-in" }
  };
  const config = channelConfig[channel] || { color: "#757575", label: channel || "Web" };
  return (
    <span className="channel-badge" style={{
      background: `${config.color}15`,
      color: config.color,
      border: `1px solid ${config.color}40`,
      padding: "2px 8px",
      borderRadius: "4px",
      fontSize: "12px",
      fontWeight: "600",
      marginLeft: "8px",
      display: "inline-flex",
      alignItems: "center"
    }}>
      {config.label}
    </span>
  );
};

// Settings Tab
const SettingsTab = ({ token }) => {
  const [settings, setSettings] = useState({
    restaurant_name: "Lee Vaakki Dhaba",
    tagline: "Authentic North Indian Cuisine",
    phone: "+91 98765 43210",
    whatsapp: "919876543210",
    email: "info@leevaakkidhaba.com",
    address_line: "NH-44, Near Murthal",
    city: "Sonipat",
    state: "Haryana",
    pincode: "131001",
    opening_hours: "Open 24 Hours",
    upi_id: "leevaakkidhaba@upi",
    google_maps_url: "https://maps.google.com/?q=Lee+Vaakki+Dhaba+Murthal",
    facebook_url: "",
    instagram_url: "",
    delivery_radius_km: 10,
    min_order_amount: 200,
    delivery_fee: 40
  });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      const res = await axios.get(`${API}/settings`);
      setSettings(prev => ({ ...prev, ...res.data }));
    } catch (err) {
      console.log("Using default settings");
    }
    setLoading(false);
  };

  const saveSettings = async () => {
    setSaving(true);
    try {
      await axios.put(`${API}/admin/settings`, settings, { headers: { Authorization: `Bearer ${token}` } });
      setSaved(true);
      setTimeout(() => setSaved(false), 3000);
    } catch (err) {
      alert("Failed to save settings");
    }
    setSaving(false);
  };

  if (loading) {
    return <div className="settings-loading"><RefreshCw className="spin" size={24} /> Loading settings...</div>;
  }

  return (
    <div className="settings-tab">
      {saved && (
        <div className="save-success">
          <CheckCircle size={18} /> Settings saved successfully!
        </div>
      )}

      {/* Restaurant Info */}
      <div className="settings-section">
        <h3><Globe size={20} /> Restaurant Information</h3>
        <div className="settings-grid">
          <div className="setting-group">
            <label>Restaurant Name</label>
            <input 
              type="text" 
              value={settings.restaurant_name} 
              onChange={e => setSettings({ ...settings, restaurant_name: e.target.value })}
              placeholder="Your Restaurant Name"
            />
          </div>
          <div className="setting-group">
            <label>Tagline</label>
            <input 
              type="text" 
              value={settings.tagline} 
              onChange={e => setSettings({ ...settings, tagline: e.target.value })}
              placeholder="Short description"
            />
          </div>
        </div>
      </div>

      {/* Contact Details */}
      <div className="settings-section">
        <h3><Phone size={20} /> Contact Details</h3>
        <div className="settings-grid">
          <div className="setting-group">
            <label>Phone Number</label>
            <input 
              type="tel" 
              value={settings.phone} 
              onChange={e => setSettings({ ...settings, phone: e.target.value })}
              placeholder="+91 98765 43210"
            />
          </div>
          <div className="setting-group">
            <label>WhatsApp Number (for notifications)</label>
            <input 
              type="text" 
              value={settings.whatsapp} 
              onChange={e => setSettings({ ...settings, whatsapp: e.target.value })}
              placeholder="919876543210"
            />
            <small>Without + sign, e.g., 919876543210</small>
          </div>
          <div className="setting-group">
            <label>Email</label>
            <input 
              type="email" 
              value={settings.email} 
              onChange={e => setSettings({ ...settings, email: e.target.value })}
              placeholder="info@restaurant.com"
            />
          </div>
          <div className="setting-group">
            <label>Opening Hours</label>
            <input 
              type="text" 
              value={settings.opening_hours} 
              onChange={e => setSettings({ ...settings, opening_hours: e.target.value })}
              placeholder="Open 24 Hours"
            />
          </div>
        </div>
      </div>

      {/* Address */}
      <div className="settings-section">
        <h3><MapPin size={20} /> Location & Address</h3>
        <div className="settings-grid">
          <div className="setting-group full-width">
            <label>Address Line</label>
            <input 
              type="text" 
              value={settings.address_line} 
              onChange={e => setSettings({ ...settings, address_line: e.target.value })}
              placeholder="Street address"
            />
          </div>
          <div className="setting-group">
            <label>City</label>
            <input 
              type="text" 
              value={settings.city} 
              onChange={e => setSettings({ ...settings, city: e.target.value })}
              placeholder="City"
            />
          </div>
          <div className="setting-group">
            <label>State</label>
            <input 
              type="text" 
              value={settings.state} 
              onChange={e => setSettings({ ...settings, state: e.target.value })}
              placeholder="State"
            />
          </div>
          <div className="setting-group">
            <label>Pincode</label>
            <input 
              type="text" 
              value={settings.pincode} 
              onChange={e => setSettings({ ...settings, pincode: e.target.value })}
              placeholder="Pincode"
            />
          </div>
          <div className="setting-group">
            <label>Google Maps URL</label>
            <input 
              type="url" 
              value={settings.google_maps_url} 
              onChange={e => setSettings({ ...settings, google_maps_url: e.target.value })}
              placeholder="https://maps.google.com/..."
            />
          </div>
        </div>
      </div>

      {/* Payment & Delivery */}
      <div className="settings-section">
        <h3><IndianRupee size={20} /> Payment & Delivery</h3>
        <div className="settings-grid">
          <div className="setting-group">
            <label>UPI ID (for payments)</label>
            <input 
              type="text" 
              value={settings.upi_id} 
              onChange={e => setSettings({ ...settings, upi_id: e.target.value })}
              placeholder="yourname@upi"
            />
          </div>
          <div className="setting-group">
            <label>Delivery Radius (km)</label>
            <input 
              type="number" 
              value={settings.delivery_radius_km} 
              onChange={e => setSettings({ ...settings, delivery_radius_km: parseInt(e.target.value) || 0 })}
              placeholder="10"
            />
          </div>
          <div className="setting-group">
            <label>Minimum Order Amount (₹)</label>
            <input 
              type="number" 
              value={settings.min_order_amount} 
              onChange={e => setSettings({ ...settings, min_order_amount: parseFloat(e.target.value) || 0 })}
              placeholder="200"
            />
          </div>
          <div className="setting-group">
            <label>Delivery Fee (₹)</label>
            <input 
              type="number" 
              value={settings.delivery_fee} 
              onChange={e => setSettings({ ...settings, delivery_fee: parseFloat(e.target.value) || 0 })}
              placeholder="40"
            />
          </div>
        </div>
      </div>

      {/* Social Media */}
      <div className="settings-section">
        <h3><MessageCircle size={20} /> Social Media</h3>
        <div className="settings-grid">
          <div className="setting-group">
            <label>Facebook Page URL</label>
            <input 
              type="url" 
              value={settings.facebook_url} 
              onChange={e => setSettings({ ...settings, facebook_url: e.target.value })}
              placeholder="https://facebook.com/..."
            />
          </div>
          <div className="setting-group">
            <label>Instagram Profile URL</label>
            <input 
              type="url" 
              value={settings.instagram_url} 
              onChange={e => setSettings({ ...settings, instagram_url: e.target.value })}
              placeholder="https://instagram.com/..."
            />
          </div>
        </div>
      </div>

      {/* Save Button */}
      <div className="settings-actions">
        <button className="save-settings-btn" onClick={saveSettings} disabled={saving}>
          <Save size={18} /> {saving ? "Saving..." : "Save Settings"}
        </button>
      </div>
    </div>
  );
};

export default AdminDashboard;
